import axios from 'axios';
import { CONFIG } from 'src/config-global';
// import {environment} from '../environment/environment';

class Services {
  // Call at the very beginning
  static init(): void {
    axios.defaults.timeout = CONFIG.reqTimeout;
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.baseURL = CONFIG.baseUrl;
  }

  // Call after authentication is done and make required changes
  static initAfterAuth(config: { token: string }): void {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    axios.defaults.headers.common['authorization'] = `Bearer ${config?.token || ''}`;
  }

  // The generic handling of errors
  static genericErrorHandler(error: any): void {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
}

export default Services;
